import { connect } from "react-redux";

import { OauthCallBackComponent } from "src/components/oauth_callback_component";

export const OauthCallBackContainer = connect()(OauthCallBackComponent);
